'use client';

import classNames from 'classnames';
import Input from 'components/gruenland/atoms/input';
import { useFormat } from 'helpers/hooks/useFormat';
import { COMPANY_ADDRESS, COMPANY_FAX, COMPANY_NAME, COMPANY_PHONE, COMPANY_VAT_CODE } from 'project.config';
import Column1, { FooterLink } from './atoms/Column1';
import Column2 from './atoms/Column2';
import { FooterMenuLabel } from './atoms/FooterMenuLabel';

export interface FooterColumn {
  header?: string;
  links?: FooterLink[];
}
export interface Props {
  column1: FooterColumn;
  column2: FooterColumn;
  legalMenu: FooterColumn;
  className?: string;
}

export const FooterMenu: React.FC<Props> = ({ column1, column2, legalMenu, className }) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  return (
    <div className={classNames('flex flex-col gap-6 md:flex-row md:gap-[80px]', className)}>
      <div className="grow-[8]">
        <FooterMenuLabel>
          {formatMessage({ id: 'newsletter.label', defaultMessage: 'Iscriviti alla newletter' })}
        </FooterMenuLabel>
        <p className="mt-4">
          {formatMessage({
            id: 'newsletter.description',
            defaultMessage: 'Resta aggiornato su tutte le nostre novità',
          })}
        </p>

        <form className="mt-3" method="get" action="/newsletter">
          <Input
            variant="secondary"
            id="email"
            name="email"
            type="email"
            autoComplete="email"
            required
            placeholder={formatMessage({ id: 'newsletter.placeholder', defaultMessage: 'Inserisci la tua email' })}
          />
        </form>
      </div>
      <div className="grow-[5]">
        <Column1 header={column1.header} links={column1.links ?? []} />
      </div>
      <div className="grow-[5]">
        <Column2 header={column2.header} links={column2.links ?? []} />
      </div>
      <div className="grow-[5] md:hidden">
        <Column1 header={legalMenu.header} links={legalMenu.links ?? []} />
      </div>
      <div className="hidden grow-[5] md:block">
        {COMPANY_NAME}
        <br />
        P.Iva {COMPANY_VAT_CODE}
        <br />
        {COMPANY_ADDRESS}
        <br />
        Tel. {COMPANY_PHONE}
        <br />
        Fax {COMPANY_FAX}
      </div>
    </div>
  );
};
